import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { billingKeys } from '../queries/keys';
import { billingPaths } from '../queries/paths';

// TSS vite/03 — estadías de manejo por vaca (admin-billing-stays.md). Rango medio-abierto;
// no-solape por vaca, a lo sumo una abierta. Fuente derivada de los días de pensión.
// Permiso billing:*.

export function useStays(animalId) {
    return useQuery({
        queryKey: billingKeys.stays(animalId),
        queryFn:  ({ signal }) => api.get(billingPaths.stays(), { params: { animal_id: animalId }, signal }).then(r => r.data),
        enabled:  !!animalId,
    });
}

export function useCheckInStay() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(billingPaths.stays(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}

export function useMoveStay() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(billingPaths.stayMove(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}

export function useCloseStay() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(billingPaths.stayClose(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}

export function useDeleteStay() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.delete(billingPaths.stay(id)).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}
